<template>
  <div class="error-modular">
    <div class="error-body-modular">
      <img class="error-bg" src="../assets/error/error-bg.png" alt="">
      <div class="error-content-modualr">
        <div class="error-title">{{ $t("translateText.pagelostText") }}</div>
        <div class="error-content">
          <p>{{ countDown }}{{ $t("translateText.pagelostText1") }}</p>
        </div>
        <div class="error-operation-btn">
          <el-button class="refresh-btn">
            <img class="refresh-icon" src="../assets/error/refresh-icon.png" alt="">
            <span>{{ $t("translateText.pagelostText2") }}</span>
          </el-button>
          <el-button class="return-home-btn">
            <img class="return-icon" src="../assets/error/home-icon.png" alt="">
            <span>{{ $t("translateText.pagelostText3") }}</span>
          </el-button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>


export default {

  data() {
    return {
      countDown: 10,
      countDownSetInterval: '',
    };
  },
  methods: {
    /**
     * 倒计时
     */
    countDownTime() {
      let that = this;
      that.countDownSetInterval = setInterval(() => {
        that.countDown--;
        if (that.countDown == 0) {
          that.countDown = 0;
          // 清除定时器
          clearInterval(that.countDownSetInterval)
        }
      }, 1000);
    }
  },
  mounted() {
    let that = this;
    // 选中产品菜单
    that.countDownTime();
  },
};
</script>


// WEBPACK FOOTER //
// src/view/error.vue